import React  from 'react';
import Button from '@mui/material/Button';
//import { useTheme } from '@mui/material/styles';
//import { LineChart, Line, XAxis, YAxis, Label, ResponsiveContainer } from 'recharts';
import Title from './Title';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import Table from '@material-ui/core/Table';
// import TableHead from '@material-ui/core/TableHead';
// import TableRow from '@material-ui/core/TableRow';
// import TableCell from '@material-ui/core/TableCell';
// import TableBody from '@material-ui/core/TableBody';
// import Box from '@mui/material/Box';
//import Paper from '@mui/material/Paper';
import { ThemeProvider } from '@material-ui/core'
import { createTheme } from '@material-ui/core/styles';
import {Tooltip} from '@mui/material';



const theme = createTheme({
  overrides: {
    MuiTableCell: {
      root: {  //This can be referred from Material UI API documentation. 
        padding: '0px 4px',
        // backgroundColor: "#eaeaea",
      },
    },
  },
});

const handleClipboardCopy = (url,spanId) => {
  navigator.clipboard.writeText(url);
  var spanItem = document.getElementById(spanId);
  //console.log(tooltip);
  spanItem.innerHTML = '&nbsp;&nbsp;&nbsp; Copied!';

  setTimeout(function () {
    spanItem.innerHTML = '';
  }, 1000);
  
};

const tooltipPrefix = 'tooltip';
const spanPrefix = 'span';

const ReportCard = (props) => {
  return (
    <React.Fragment>
      
      <ThemeProvider theme={theme}>
        <Title>{props.title}</Title>
        
        {props.rows.map((report, index) => <div key = {index}><a href={report.reportUrl} target='_blank' rel="noreferrer">{report.reportName}  </a><Tooltip id ={tooltipPrefix+index} title = 'Click to copy URL for sharing'><Button onClick={() =>  handleClipboardCopy(report.reportUrl,spanPrefix+index)}><ContentCopyIcon  ></ContentCopyIcon> <span id={spanPrefix+index}></span> </Button></Tooltip> (run {report.invoked} times)</div>)}
         {/* {props.rows.map((report, index) => <p>{report.reportName}</p>} */}
         

       
      </ThemeProvider>
    </React.Fragment>
  );
}
export default ReportCard;